import _taggedTemplateLiteral from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\n  border: 1px solid ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 0;\n\n  .uppy-Dashboard-close,\n  .uppy-DashboardContent-addMore {\n    display: none;\n  }\n\n  .uppy-DashboardContent-bar {\n    display: flex;\n    justify-content: space-between;\n    padding: ", "rem;\n    border-bottom: 1px solid ", ";\n  }\n\n  button {\n    border: 0;\n    padding: 0;\n    color: ", ";\n    text-decoration: underline;\n    cursor: pointer;\n  }\n\n  .uppy-Dashboard-files {\n    display: block;\n    margin: 0;\n    padding: ", "rem;\n  }\n\n  .uppy-DashboarAddFiles {\n    padding: ", "rem;\n  }\n\n  .uppy-DashboardItem {\n    display: flex;\n    justify-content: space-between;\n    margin: 0;\n    padding: 0;\n  }\n\n  .uppy-DashboardItem-preview {\n    display: none;\n  }\n\n  .uppy-DashboardItem-name {\n    display: inline-block;\n    font-weight: bold;\n    word-break: break-all;\n  }\n\n  .uppy-DashboardItem-status {\n    display: inline-block;\n    font-size: 80%;\n    margin-left: ", "rem;\n  }\n\n  .uppy-Dashboard-inner {\n    text-align: center;\n\n    label {\n      display: block;\n      padding-top: ", "rem;\n      color: ", ";\n      cursor: pointer;\n    }\n\n    svg {\n      fill: ", ";\n      width: 15px;\n      height: 15px;\n    }\n  }\n\n  .uppy-Dashboard-innerWrap {\n    transition: background-color .3s ease-in-out;\n  }\n\n  .uppy-Dashboard.drag .uppy-Dashboard-innerWrap {\n    background-color: ", ";\n  }\n\n\n\n  /* Progress bar */\n\n  .uppy-ProgressBar {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 5px;\n    margin-top: -5px;\n    z-index: 10000;\n    transition: height 0.2s;\n  }\n\n  .uppy-ProgressBar-inner {\n    background-color: ", ";\n    border-radius: 0 0 ", "\n      ", ";\n    height: 100%;\n    width: 0;\n    transition: width 0.4s ease;\n  }\n\n  .uppy-ProgressBar-percentage {\n    display: none;\n    text-align: center;\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 80%;\n    color: ", ";\n\n    &:after {\n      content: ' %';\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * @file Created on Tue Aug 14 2018
 * @author SKu
 */
import styled, { withTheme } from 'styled-components';
var FileUploaderStyled = styled.div(_templateObject(), function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.theme.colors.paper;
}, function (props) {
  return props.theme.common.borderRadius;
}, function (props) {
  return props.theme.spacing.spacer;
}, function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.theme.colors.link;
}, function (props) {
  return props.theme.spacing.spacer;
}, function (props) {
  return props.theme.spacing.spacer;
}, function (props) {
  return props.theme.spacing.spacer;
}, function (props) {
  return props.theme.spacing.spacer;
}, function (props) {
  return props.theme.colors.link;
}, function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.colors.focus;
}, function (props) {
  return props.theme.colors.secondary;
}, function (props) {
  return props.theme.common.borderRadius;
}, function (props) {
  return props.theme.common.borderRadius;
}, function (props) {
  return props.theme.colors.muted;
});
export default withTheme(FileUploaderStyled);